import { combineReducers } from 'redux';

import incidents from './incidents';
import tableActions from './tableActions';
import tableActionsBookmarkStatus from './tableActionsBookmarkStatus';
import tableExportActions from './tableExportActions';
import tableExportBrandPermission from './tableExportBrandPermission';
import tableExportPiracyPermission from './tableExportPiracyPermission';

const table = {
  incidents,
  tableActions,
  tableActionsBookmarkStatus,
  tableExportActions,
  tableExportBrandPermission,
  tableExportPiracyPermission,
};

export default combineReducers(table);
